/* jshint node:true */
'use strict';

var createStore             = require('fluxible/addons').createStore;
var PersistentStateMixin    = require('../mixins/PersistentStateMixin');
var DateFormatMixin         = require('../mixins/DateFormatMixin');

var storeSchedule = createStore({

    storeName: 'ScheduleStore',

    mixins: [PersistentStateMixin,DateFormatMixin],

    initialize: function() {
        this.data = {
            events:{}
        };
    },

    handlers: {
        RECEIVED_SCHEDULE: function(payload) {

            //this.data.sport       = payload.sport;
            //this.data.league      = payload.league;

            this._formatData(payload.data,payload.sport,payload.league);

            //console.log(this.data.events);

            this.emitChange();
        }
    },

    haveData: function(sSport,sLeague,sDateKey){
        if(typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined' || typeof this.data.events[sSport][sLeague].events[sDateKey] === 'undefined'){
            return false;
        }
        return true;
    },

    getLeagueName: function(sSport,sLeague){
        if(typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined' || typeof this.data.events[sSport][sLeague].name === 'undefined'){
            return '';
        }
        return this.data.events[sSport][sLeague].name;
    },

    getDefaultDate: function(sSport,sLeague){
        if(typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined' || typeof this.data.events[sSport][sLeague].defaultDate === 'undefined'){
            return '';
        }
        return this.data.events[sSport][sLeague].defaultDate;
    },

    getCalendar: function(sSport,sLeague){
        if(typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined' || typeof this.data.events[sSport][sLeague].calendar === 'undefined'){
            return [];
        }
        return this.data.events[sSport][sLeague].calendar;
    },

    getSchedule: function(sSport,sLeague,oDate) {

        var sDateKey = 0;
        if(!oDate){
            sDateKey = this.getDateKey(sSport,sLeague);
        }else{
            sDateKey = this.dateToObject(oDate).getTime();
        }

        /* no data for this sport or date */
        if(typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined' || typeof this.data.events[sSport][sLeague].events[sDateKey] === 'undefined'){
            return null;
        }

        return this.data.events[sSport][sLeague].events[sDateKey];
    },

    getRelatedDates: function(sSport,sLeague,sDateKey) {

        if(!sDateKey){
            sDateKey = this.getDateKey(sSport,sLeague);
        }

        /* no data for this sport or date */
        if(typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined' ||  typeof this.data.events[sSport][sLeague].events[sDateKey] === 'undefined'){
            return [];
        }
        return this.data.events[sSport][sLeague].events[sDateKey].otherDates || [];

    },

    getDateKey: function(sSport,sLeague){
        /* takes todays date and works out the closest date in the available sports */
        if(typeof this.data.events[sSport] === 'undefined' || typeof this.data.events[sSport][sLeague] === 'undefined'){
            return null;
        }

        for(var sDatekey in this.data.events[sSport][sLeague].events){
            return sDatekey;
        }
    },

    _formatData: function(oData,sSport,sLeague) {

        var iDaysForward    = 0;
        var sLeagueName     = '';
        var iFirstDate      = 0;

        if(typeof oData.events === 'undefined'){
            return [];
        }

        /* set up data */
        if(typeof this.data.events[sSport] === 'undefined'){
            this.data.events[sSport] = {};
        }

        if(typeof this.data.events[sSport][sLeague] === 'undefined'){
            this.data.events[sSport][sLeague] = {};
        }

        if(typeof this.data.events[sSport][sLeague].events === 'undefined'){
            this.data.events[sSport][sLeague].events = {};
            this.data.events[sSport][sLeague].name = '';
            this.data.events[sSport][sLeague].defaultDate = null;
        }

        /* itterate other dates and jump forward by X? */
        var aAltDates = [];
        if(typeof oData.leagues !== 'undefined' && typeof oData.leagues[0] !== 'undefined' && typeof oData.leagues[0].calendar !== 'undefined'){
            this.data.events[sSport][sLeague].calendar = [];
            this.data.events[sSport][sLeague].name = oData.leagues[0].name;
            for(var i = 0; i < oData.leagues[0].calendar.length; i++){
                aAltDates.push(this.dateToObject(oData.leagues[0].calendar[i]));
            }
            this.data.events[sSport][sLeague].calendar = aAltDates;
        }

        var oEvents = this.data.events[sSport][sLeague].events;

        /* itterate the events */
        for(var i = 0; i < oData.events.length; i++){
            var oEvent = oData.events[i];

            if(typeof oEvent.competitions === 'undefined' || typeof oEvent.date === 'undefined'){
                continue;
            }

            var oEventData = {
                homeTeam:null,
                awayTeam:null,
                thisGameDate:null,
                time:null,
                displayTime:null,
                result:null,
                link:null,
                note:'',
                gameId:null,
                tv:null,
                betting:null,
                tickets:null,
                soccerRecord:'v',
                timeValid:false,
                gameState:null,
                period:null,
                attendance:'N/A',
                location:'--'
            };

            /* get the start time */
            var dEventDate  = new Date(oEvent.date);
            oEventData.time = oEvent.date;
            oEventData.displayTime= this.dateFormat(oEvent.date,'time1');
            var sDateKey    = dEventDate.setHours(0,0,0,0);

            if(!iFirstDate){
                iFirstDate = dEventDate.getTime();
            }

            /* get the game state  */
            if(typeof oEvent.status !== 'undefined' && typeof oEvent.status.type !== 'undefined' &&  typeof oEvent.status.type.state !== 'undefined'){
                oEventData.gameState    = oEvent.status.type.state;
                oEventData.result       = oEvent.status.type.shortDetail;
                oEventData.period       = oEvent.status.period || 0;

                if(oEventData.gameState === 'in'){
                    oEventData.gameState === 'live';
                }

            }else{

                oEventData.gameState = 'pre';

            }

            /* original code makes and assuption there is only 1 competition so i will do the same. */
            var oCompetition = oEvent.competitions[0];

            /* get the team data */
            var oHomeAway = this._getCompetitors(oCompetition.competitors);
            oEventData.homeTeam = oHomeAway.homeTeam;
            oEventData.awayTeam = oHomeAway.awayTeam;

            /* set is time valid? */
            oEventData.timeValid = oCompetition.timeValid  || false;

            /* Game id = compid */
            oEventData.gameId = oCompetition.id;

            /* Get the game venue */
            if(typeof oCompetition.venue !== 'undefined'){

                var sVenue   = oCompetition.venue.fullName || '';
                var sCountry = oCompetition.venue.address.country || null;
                var sCity    = oCompetition.venue.address.city || null;

                if(sCity != null){
                    sVenue = sVenue + ', ' + sCity;
                }

                if(sCountry != null && sLeague != 'usa.1'){
                    sVenue = sVenue + ', ' + sCountry;
                }

                oEventData.location = sVenue;
            }

            /* Build a map of all the links for easy reference */
            var rLinkMap = {}
            for(var v = 0; v < oEvent.links.length; v++){
                var oLink       = oEvent.links[v];
                var sLinkKey    = oLink.text.toLowerCase().replace(' ','');
                var oBetLink    = {};

                oBetLink.href = oLink.href || '#';
                oBetLink.text = oLink.text;
                oBetLink.isExternal = oLink.isExternal || false;

                rLinkMap[sLinkKey] = oBetLink;
            }

            /* Build the game links */
            var rLinkTypeMap = {
                preLink:'preview',
    			liveLink:'gamecast',
    			secondLiveLink :'play-by-play',
    			postLink:'recap',
    			secondPostLink:'box score',
    			default:'conversation'
			};

			if(sSport === 'soccer' || sSport === 'rugby'){
				rLinkTypeMap = {
				    default:'statistics',
				    postLink:'report',
				    secondLiveLink:'statistics',
				    secondPostLink:'statistics'
				}
			}

			oEventData.link = rLinkMap['default'];
			if(oEventData.gameState === 'pre'){
				oEventData.link = rLinkMap[rLinkTypeMap['preLink']] ? rLinkMap[rLinkTypeMap['preLink']] : rLinkMap[rLinkTypeMap['default']];
			} else if(oEventData.gameState === 'live'){
				oEventData.link = rLinkMap[rLinkTypeMap['liveLink']] ? rLinkMap[rLinkTypeMap['liveLink']] : rLinkMap[rLinkTypeMap['secondLiveLink']];
			} else if(oEventData.gameState === 'post'){
				oEventData.link = rLinkMap[rLinkTypeMap['postLink']] ? rLinkMap[rLinkTypeMap['postLink']] : rLinkMap[rLinkTypeMap['secondPostLink']];
			}
			//link = call format.util.href(params, link);

			//if(notes != null and (sport == "soccer" or seasonType == 3)){
			//	note = call t.find(notes, "headline");
			//}


            /* build post game data */
            if(oEventData.gameState == 'post'){

                if(sSport === 'soccer'){

                    /* get and format the attendance */
                    if(typeof oCompetition.attendance !== 'undefined' && oCompetition.attendance > 0){
                        oEventData.attendance = this._numberWithCommas(oCompetition.attendance);
                    }

                    var iLeg = null;
                    if(typeof oCompetition.leg !== 'undefined' && typeof oCompetition.leg.value !== 'undefined'){
                        iLeg = oCompetition.leg.value;
                    }

                    /* build the score */
                    if(iLeg == 2 && oEventData.homeTeam.aggregateScore != null &&  oEventData.awayTeam.aggregateScore != null){
                    	oEventData.soccerRecord = oEventData.homeTeam.score+' ('+oEventData.homeTeam.aggregateScore+') - ('+oEventData.awayTeam.aggregateScore+') '+oEventData.awayTeam.score;
                    } else {
                    	oEventData.soccerRecord = oEventData.homeTeam.score+' - '+oEventData.awayTeam.score;
                    }

					if (iLeg != null && iLeg > 0){

						if (oEventData.note !== ''){
						    oEventData.note += ' - '
						}

						oEventData.note += this.getOrdinal(iLeg) + ' Leg';

						/* build aggeragate winner text */
						if(oEventData.gameState !== 'pre'){
							oEventData.note += this._getSoccerNote(oEventData.homeTeam,oEventData.awayTeam,iLeg,'aggregate',oEventData.period);
						}
					}

					/* build penalties text */
					if (oEventData.gameState !== 'pre' && (oEventData.homeTeam.shootoutScore > 0 || oEventData.awayTeam.shootoutScore > 0)){
						oEventData.note += this._getSoccerNote(oEventData.homeTeam,oEventData.awayTeam,iLeg,'penalties',oEventData.period);
					}

                }else{

                }

            }else{

            	/* build the betting links */
            	var oBetLink = rLinkMap.bet365;
                if(oBetLink){
                    oBetLink.linkTrack = 'bet365';
                    oBetLink.text = 'Football Odds with Bet365';
                }
                oEventData.betting = oBetLink;

            }

            /* if before or in match set to time */
            if (oEventData.gameState == 'pre' || oEventData.gameState == 'live'){
				oEventData.result = oEventData.displayTime;
			}

            /* build the tickets Links */
        	/*
        	gcid = call format.util.advertising.stubhub.shGCID(sport&'schedule');
        	if(ticketInfo != null){
        		ticketText = optString(ticketInfo, "summary");
        		ticketLink = call t.find(ticketInfo, #("links", 0, "href"));
        		numAvailable = optInt(ticketInfo, 'numberAvailable');
        		ticketText = replace(ticketText, 'available', '<span id="ticketAvailable">available</span>');
        		keyword = homeDisplayName;
        		keyword = replace(toLowerCase(keyword), ' ', '+');
        		if(sport != 'soccer'){
        			if(numAvailable == 0){
        				ticketText = 'Buy on StubHub';
        				ticketLink = 'http://www.stubhub.com/';
        			}
        			ticketLink = ticketLink & '?gcid=' & gcid & '&keyword=' & keyword;
        		}
        	} else {
        		if(sport != 'soccer'){
        			if(homeTeamActive){
        				generateSHLink = 'http://stubhub.com/';
        				slug = replace(toLowerCase(homeDisplayName), ' ', '-') & '-tickets/';
        				ticketLink = generateSHLink & slug & '?gcid=' & gcid;
        				ticketText = 'Buy on StubHub';
        			}
        		}
        	}
        	*/

        	/* set up output or reset if we are getting it again */
        	if(typeof oEvents[sDateKey] === 'undefined' || i == 0){
        	    oEvents[sDateKey] = {};
        	    oEvents[sDateKey].key           = sDateKey;
        	    oEvents[sDateKey].displayValue  = this.dateFormat(oEvent.date,'date10');
        	    oEvents[sDateKey].incomplete    = [];
        	    oEvents[sDateKey].complete      = [];
        	}

        	if (oEventData.gameState != 'post'){
                oEvents[sDateKey].incomplete.push(oEventData);
            }else{
                oEvents[sDateKey].complete.push(oEventData);
            }

        }

        this.data.events[sSport][sLeague].defaultDate = iFirstDate;

    /*
    {
        homeTeam={
            id=3132,
            name=Randers FC,
            abbrev=Randers FC,
            displayName=Randers FC,
            logo=null,
            link=http://espn.co.uk/football/club/_/id/3132
        },
        awayTeam={id=5243, name=UE Sant Julia, abbrev=UE Sant Juli, displayName=UE Sant Julia, logo=http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/5243.png&h=50, link=http://espn.co.uk/football/club/_/id/5243},
        thisGameDate=2015-07-09T17:05Z,
        result=1:05 PM ET,
        link=http://en.espn.co.uk/football/sport/match/redirect.html?espn_fc_id=426274,
        note=null,
        gameId=426274,
        columns={tv=null,betting={ticketText=Football Odds with Bet365, ticketLink=null, isExternal=true, linkTrack=bet365}},
        soccerRecord=v,
        timeValid=true
    }
    */
    },

    _getSoccerNote: function(oHomeTeam,oAwayTeam,iLeg,sType,iPeriod){

        if(iLeg <=1){
            return '';
        }

        var sNote           = '';
        var sResult         = '';
        var bTied           = false;
        var sWillAdvance    = oHomeTeam.name;
        //var sWonMatch       = oHomeTeam.name;
        var sWinning        = null;
        var iHomeScore      = sType === 'aggregate' ? oHomeTeam.aggregateScore : oHomeTeam.shootoutScore;
        var iAwayScore      = sType === 'aggregate' ? oAwayTeam.aggregateScore : oAwayTeam.shootoutScore;
        var iFirstScore     = iHomeScore;
        var iSecondScore    = iAwayScore;

        if(iAwayScore>iHomeScore){
            sWinning = oAwayTeam.name;
        }else if(iAwayScore<iHomeScore){
            sWinning = oHomeTeam.name;
        }

        if(oAwayTeam.willAdvance){
            sWillAdvance = oAwayTeam.name;
            iFirstScore = iAwayScore;
            iSecondScore = iHomeScore;
        }

        //if(oAwayTeam.isWinner){
        //    sWonMatch = oAwayTeam.name;
        //}

        sResult = sWillAdvance + ' win';
        if(iHomeScore === iAwayScore){
            sResult = 'Tied';
            if(sType === 'aggregate' && iPeriod != 5){
                bTied = true;
            }
        }else if (sWinning != null && sWillAdvance !== sWinning) {
           sResult = sWinning + ' lead';
        }

        sNote = ' - ' + sResult + ' ' + iFirstScore + '-' + iSecondScore + ' on ' + sType;

        if(bTied){
			sNote += ' - ' + sWillAdvance + ' advances';
		}

		return sNote;

    },

    _getCompetitors: function(oCompetitors){

        var rComps = {
            homeTeam:null,
            awayTeam:null,
        }

        if(typeof oCompetitors === 'undefined'){
            return rComps;
        }

        for(var i = 0; i < oCompetitors.length; i++){
            var oCompetitor = oCompetitors[i];
            if(oCompetitor.homeAway === 'home'){
                rComps.homeTeam = this._getTeamInformation(oCompetitor.team);
                rComps.homeTeam.isWinner        = oCompetitor.winner || false;
                rComps.homeTeam.willAdvance     = oCompetitor.advance || false;
                rComps.homeTeam.score           = oCompetitor.score || 0;
                rComps.homeTeam.aggregateScore  = oCompetitor.aggregateScore || 0;
                rComps.homeTeam.shootoutScore   = oCompetitor.shootoutScore || 0;

            }else{
                rComps.awayTeam = this._getTeamInformation(oCompetitor.team);
                rComps.awayTeam.isWinner        = oCompetitor.winner || false;
                rComps.awayTeam.willAdvance     = oCompetitor.advance || false;
                rComps.awayTeam.score           = oCompetitor.score || 0;
                rComps.awayTeam.aggregateScore  = oCompetitor.aggregateScore || 0;
                rComps.awayTeam.shootoutScore   = oCompetitor.shootoutScore || 0;

            }
        }

        return rComps;
    },

    _getTeamInformation: function(oTeamData){

        var iLogoSize = 25;

        var rTmpTeam = {
            id:null,
            name:null,
            abbrev:null,
            displayName:null,
            hasLogo:false,
            logo:'http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/default-team-logo-500.png&h='+iLogoSize,
            link:'#',
            isActive:false,
            willAdvance:false,
            advance:false,
            score:null,
            aggregateScore:null,
            shootoutScore:null
        };

        rTmpTeam.id         = parseInt(oTeamData.id) || null;
        rTmpTeam.name       = oTeamData.name || null;
        rTmpTeam.abbrev     = oTeamData.abbreviation || null;
        rTmpTeam.displayName= oTeamData.displayName || null;
        rTmpTeam.isActive   = oTeamData.isActive || false;

        // get image or leave as default
        var sTmpLogo = this._imageToCombiner({image:oTeamData.logo,height:iLogoSize});
        if(sTmpLogo !== null){
            rTmpTeam.logo = sTmpLogo;
            rTmpTeam.hasLogo = true;
        }

        /* search for clubhouse links */
        for(var i = 0; i < oTeamData.links.length; i++){
            var oLink = oTeamData.links[i];
            if(oLink['text'] === 'Clubhouse'){
                rTmpTeam.link = oLink.href || '#';
            }
        }

        return rTmpTeam;
    },

    _numberWithCommas: function(x) {
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    },

    getOrdinal: function(n) {
       var s=["th","st","nd","rd"],
           v=n%100;
       return n+(s[(v-20)%10]||s[v]||s[0]);
    },

    _imageToCombiner: function(oOpts){

        var sImage      = oOpts.image || null;
        var h           = oOpts.height || null;
        var w           = oOpts.width || null;
        var sImageUrl   = null;
        var sImageRef   = 'http://a.espncdn.com';
        var bFromSoccer = false;

        if(sImage != null){
        	var iImagedomainEnd = sImage.indexOf('.com/');
        	if(iImagedomainEnd > -1){
        		iImagedomainEnd = iImagedomainEnd + 4;
        		sImageRef = sImage.substring(0, iImagedomainEnd);
        		var sOriginalRef = sImageRef;
        		if(sImage.indexOf('i.espncdn.com') > -1){
        			bFromSoccer = true;
        			sImageRef = replace(sImageRef, 'i.', 'a.');
        		}
        		sImageUrl = sImageRef+'/combiner/i?img=';
        		if(bFromSoccer){
        			sImageUrl = sImageUrl+'/soccernet';
        		}
        		sImageUrl = sImageUrl+sImage.replace(sOriginalRef, '');
        		if(h != null){
        			sImageUrl = sImageUrl+'&h='+h;
        		}
        		if(w != null){
        			sImageUrl = sImageUrl+'&w='+w;
        		}
        	}
        }

        return sImageUrl;

    }

});

module.exports = storeSchedule;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/stores/ScheduleStore.js
 **/